import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import {changePasswordPost} from '../controllers/authController';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, parseISO } from 'date-fns';
import { toast } from 'react-toastify';

const ChangePasswordView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState({
        old_password: '',
        new_password: '',
    });

    var magazine_id = null;
    var magazineL = localStorage.getItem('magazine');

    useEffect(() => {
        if (magazineL) {
            magazine_id = JSON.parse(magazineL).magazine_id;
        }
        const params = {
            magazineId: magazine_id,
        };
    }, []);


    const handleChange = (e) => {
         const { name, value } = e.target;
        setData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const params = {
            magazineId: magazine_id,
            releaseId: id
        };
        try {
            console.log(data);
            await changePasswordPost(params, data);
            toast.success("Password Change Successfully!");
            setTimeout(() => {
                navigate(`/profile`);
            }, 1000);
        } catch (error) {
            toast.error("Error in changing password.");
        }

    };



    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title fw-semibold mb-4">Change Password</h5>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-11">
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label>Old Password</label>
                                            <input
                                                name="old_password"
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label>New Password</label>
                                            <input
                                                type="text"
                                                name="new_password"
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <button type="submit" className="btn btn-success">Change Password</button>
                                        <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate(-1)}>Cancel</button>
                                    </form>

                                </div>
                                <div className="col-lg-1">
                                    <button className="btn btn-sm btn-secondary me-2" onClick={() => navigate(-1)}>
                                        Back
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePasswordView;
